import React from "react";
import { Award } from "lucide-react";
import { PROFILE } from "../../data/profile";

export default function Certifications() {
  return (
    <section
      id="certs"
      data-testid="certs-section"
      className="relative py-24 sm:py-32 border-t border-white/[0.06]"
    >
      <div className="mx-auto max-w-7xl px-5">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <span className="text-eyebrow">// 05 · Certifications</span>
            <h2 className="text-display mt-3 text-[2.6rem] sm:text-[3.4rem] leading-[0.95]">
              Receipts &{" "}
              <em className="italic text-[var(--jewel)]">credentials</em>.
            </h2>
          </div>
          <p className="text-sm text-muted-foreground max-w-md">
            Industry-recognized certifications strengthening AI, Python, problem
            solving and backend expertise.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {PROFILE.certifications.map((c, idx) => (
            <div
              key={c.title}
              data-testid={`cert-card-${idx}`}
              className="rounded-2xl border border-white/10 bg-white/[0.02] p-6 hover:border-[var(--jewel)]/40 transition-colors"
            >
              <div className="flex items-center justify-between">
                <div className="h-10 w-10 rounded-full grid place-items-center bg-[var(--jewel)]/10 text-[var(--jewel)]">
                  <Award size={18} />
                </div>
                <span className="font-mono-ed text-xs text-muted-foreground">
                  {c.year}
                </span>
              </div>
              <h3 className="mt-5 font-serif text-xl leading-snug text-foreground">
                {c.title}
              </h3>
              <p className="mt-1 font-mono-ed text-xs uppercase tracking-widest text-muted-foreground">
                {c.issuer}
              </p>
              <p className="mt-4 text-sm text-foreground/70 leading-relaxed">{c.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
